/**
 * Document extraction status enum used across the entire application
 */
export enum DocumentExtractionStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

/**
 * Type guard to check if a value is a valid DocumentExtractionStatus
 */
export function isDocumentExtractionStatus(value: any): value is DocumentExtractionStatus {
  return Object.values(DocumentExtractionStatus).includes(value)
}
